import { z } from 'zod';
import { optionalE164PhoneSchema } from './common/phone.js';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const CommunicationSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    contactSubject: z.string().min(1),
    inWhichCase: z.string().optional(),
    who: z.string().optional(),
    withWhom: z.string().optional(),
    whichMethod: z.string().optional(),
    name: z.string().optional(),
    category: z.string().optional(),
    mobile: optionalE164PhoneSchema,
    landline: optionalE164PhoneSchema,
    email: z.string().email().optional().or(z.literal("")),
    position: z.string().optional(),
    unit: optionalMongoObjectId,
    responsible: z.string().optional(),
    remarks: z.string().optional(),
    status: z.enum(['active', 'inactive']).default('active'),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
    customFields: z.record(z.unknown()).optional(),
});
export const CreateCommunicationSchema = CommunicationSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateCommunicationSchema = CommunicationSchema.partial();
export const CommunicationFormSchema = CommunicationSchema.extend({
    contactSubject: z.string().optional(),
});
